import React from 'react';
import { ButtonBase, Stack, Typography } from '@mui/material';
import { ExpandLess as ExpandLessIcon, ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import { alpha } from '@mui/material/styles';

const TimelineDisclosureToggle = ({
  expanded,
  onClick,
  label,
  children = null,
  compact = false,
  hideLabel = false,
  ariaLabel = null,
  sx = {},
}) => (
  <ButtonBase
    onClick={onClick}
    aria-expanded={expanded}
    aria-label={ariaLabel || label || undefined}
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      borderRadius: 999,
      px: compact ? 0.15 : 0.25,
      py: compact ? 0.12 : 0.18,
      color: alpha('#4B5563', 0.92),
      textAlign: 'left',
      ...sx,
    }}
  >
    <Stack direction="row" spacing={0.45} alignItems="center" sx={{ minWidth: 0 }}>
      {expanded ? (
        <ExpandLessIcon sx={{ fontSize: compact ? 18 : 19, color: '#4B5563' }} />
      ) : (
        <ExpandMoreIcon sx={{ fontSize: compact ? 18 : 19, color: '#4B5563' }} />
      )}
      {children}
      {hideLabel ? null : (
        <Typography sx={{ fontSize: compact ? '0.8rem' : '0.82rem', fontWeight: 850, lineHeight: 1.2, minWidth: 0 }}>
          {label}
        </Typography>
      )}
    </Stack>
  </ButtonBase>
);

export default React.memo(TimelineDisclosureToggle);
